import request from '@/util/request';

/**
 *  这里是收费标准的Api
 */

// 字典
export const getDict = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));
//保存
export const save = (params, options) =>
    request.post('/api/v4ward/fee/standard/save', params, options);
//获取小区
export const getNode = (params, options) =>
    request.get('api/base/property/optionNode', Object.assign({}, options, { params }));
//获取费用科目
export const getSubject = (params, options) =>
    request.get('api/v4ward/fee/subject/getSubjectList', Object.assign({}, options, { params }));
//收费规则列表
export const getList = (params, options) =>
    request.get('api/v4ward/fee/standard/page', Object.assign({}, options, { params }));
//收费规则详情
export const getDetail = (params, options) =>
    request.get('api/v4ward/fee/standard/detail', Object.assign({}, options, { params }));
//启用/停用
export const statusChange = (params, options) =>
    request.post('api/v4ward/fee/standard/statusChange', params, options);